var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TextRow from './shapes/textRow';
export default class List extends React.Component {
    render() {
        const _a = this.props, { className, style, animation } = _a, set = __rest(_a, ["className", "style", "animation"]);
        const classes = [animation ? 'cl-ContentLoader-animation' : undefined, className].filter(c => c).join(' ');
        return (React.createElement("div", { className: classes, style: style },
            React.createElement(TextRow, Object.assign({}, set, { style: { height: 8, width: '90%' } })),
            React.createElement(TextRow, Object.assign({}, set, { style: { height: 8, width: '80%', marginTop: 12, marginLeft: '6%' } })),
            React.createElement(TextRow, Object.assign({}, set, { style: { height: 8, width: '60%', marginTop: 12, marginLeft: '6%' } })),
            React.createElement(TextRow, Object.assign({}, set, { style: { height: 8, width: '90%', marginTop: 12 } })),
            React.createElement(TextRow, Object.assign({}, set, { style: { height: 8, width: '70%', marginTop: 12, marginLeft: '6%' } })),
            React.createElement(TextRow, Object.assign({}, set, { style: { height: 8, width: '30%', marginTop: 12, marginLeft: '6%' } }))));
    }
}
List.defaultProps = {
    animation: true
};
